import { ColumnApi, SortModelItem } from "ag-grid-community";

export const getSortModelFromApi = (columnApi: ColumnApi): SortModelItem[] => {
    const columnState = columnApi.getColumnState();
    const filteredStates = columnState.filter((item) => item.sort != null);

    const indexes: { [colId: string]: number } = {};
    filteredStates.forEach((state) => {
        const id = state.colId as string;
        indexes[id] = state.sortIndex;
    });

    const res = filteredStates.map((s) => {
        return { colId: s.colId, sort: s.sort };
    });

    res.sort((a: any, b: any) => indexes[a.colId] - indexes[b.colId]);

    return res;
};
